module.exports = __webpack_public_path__ + "img/footprint-arch-low.ab0a4595.svg";